import { cmsRequest } from "../Content/adapter";
import { ContentResult } from "../Content/Types";
export interface Session {
  name: string;
  canEdit: boolean;
  canPublish: boolean;
}
function parseSession(result: ContentResult<Session>): ContentResult<Session> {
  if (
    result.ok &&
    (typeof result.value?.name !== "string" ||
      typeof result.value.canEdit !== "boolean" ||
      typeof result.value.canPublish !== "boolean")
  )
    return {
      ok: false,
      code: "unsupported",
      message: "The server returned an invalid session.",
    };
  return result;
}
export const getSession = async () =>
  parseSession(await cmsRequest<Session>("/session"));
export const login = async (email: string, password: string) =>
  parseSession(
    await cmsRequest<Session>("/session", "POST", { email, password })
  );
export const logout = () => cmsRequest<boolean>("/session", "DELETE");
